"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledLink = void 0;

var _react = _interopRequireDefault(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Generic = _interopRequireDefault(require("../Link/Generic"));

var _Style = _interopRequireDefault(require("../Ui/Button/Style"));

var __jsx = _react["default"].createElement;

/**
 *
 * @deprecated use  @/src/components/ButtonNorma instead.
 */
var StyledLink = (0, _styledComponents["default"])(_Generic["default"]).withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-1g18l40-0"
})(["", ";text-decoration:none;"], _Style["default"]);
/**
 *
 * @deprecated use  @/src/components/ButtonNorma instead.
 */

exports.StyledLink = StyledLink;

var ButtonLink = function ButtonLink(_ref) {
  var children = _ref.children,
      className = _ref.className,
      primary = _ref.primary,
      primaryAlt = _ref.primaryAlt,
      primaryAltBorder = _ref.primaryAltBorder,
      secondary = _ref.secondary,
      secondaryBorder = _ref.secondaryBorder,
      neutralLightBorder = _ref.neutralLightBorder,
      warning = _ref.warning,
      danger = _ref.danger,
      small = _ref.small,
      medium = _ref.medium,
      large = _ref.large,
      wide = _ref.wide,
      shadow = _ref.shadow,
      withIcon = _ref.withIcon,
      as = _ref.as,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children", "className", "primary", "primaryAlt", "primaryAltBorder", "secondary", "secondaryBorder", "neutralLightBorder", "warning", "danger", "small", "medium", "large", "wide", "shadow", "withIcon", "as"]);
  return __jsx(StyledLink, (0, _extends2["default"])({
    className: className,
    primary: primary,
    primaryAlt: primaryAlt,
    primaryAltBorder: primaryAltBorder,
    secondary: secondary,
    secondaryBorder: secondaryBorder,
    neutralLightBorder: neutralLightBorder,
    warning: warning,
    danger: danger,
    wide: wide,
    small: small,
    medium: medium,
    large: large,
    shadow: shadow,
    withIcon: withIcon,
    forwardedAs: as
  }, props), children);
};

var _default = ButtonLink;
exports["default"] = _default;